import { NetworkManager } from '../network_manager.js';

export const OFFLINE_ADS_TOOLTIP_KEY = 'OFFLINE.ADS.CONNECT_TO_WATCH';

export function areAdsBlockedOffline(): boolean
{
  return !NetworkManager.isOnline();
}
